export const PICKER_DATE_FORMAT = 'DD/MM/yyyy'

export const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY'

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DDTHH:mm'

export const IMPORT_DATE_FORMAT = 'DD.MM.YYYY'

export const DEFAULT_MIN_DATE = '01/01/1970'
export const DEFAULT_MAX_DATE = '31/12/2060'

export const HISTORY_DATE_FORMAT = 'DD-MM-YYYY HH:mm'
export const KSEF_DATE_FORMAT = 'YYYY-MM-DD'
